import { callCloudFunction } from 'utils/cloudbase'
import { MenuModel } from './types'
import { mergeMenus } from './helper'
import { createPersist } from 'api/helper'

/**
 * 获取系统中所有菜单栏目
 * @description 用户本地缓存24小时
 */
export const getMenus = createPersist(async (): Promise<MenuModel[]> => {
    const resp = await callCloudFunction({
        action: 'getMenus'
    }) as MenuModel[]

    if (resp) {
        return mergeMenus(resp)
    } else {
        return []
    }
}, 'menus', 24 * 60 * 60)